const map = {
	"./ar/settings.json": [
		18351,
		[
			8351
		]
	],
	"./de/settings.json": [
		65443,
		[
			5443
		]
	],
	"./en/settings.json": [
		42815,
		[
			2815
		]
	],
	"./es/settings.json": [
		85582,
		[
			5582
		]
	],
	"./fa/settings.json": [
		49857,
		[]
	],
	"./fr/settings.json": [
		63769,
		[
			6150
		]
	],
	"./ja/settings.json": [
		21789,
		[
			1789
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 18619;
module.exports = webpackAsyncContext;